import { render, staticRenderFns } from "./InventoryTurnoverRateWidget.vue?vue&type=template&id=6f6cf978&"
import script from "./InventoryTurnoverRateWidget.vue?vue&type=script&lang=js&"
export * from "./InventoryTurnoverRateWidget.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTurnoverRateWidget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QItem,QItemSection,QInput,QSeparator,QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QItem,QItemSection,QInput,QSeparator,QTable,QTr,QTh,QTd})
